import {Route, Routes} from 'react-router-dom';
import Role from './nhom-quyen';

export default function Config() {

  return (
    <Routes>
      <Route path="/nhom-quyen" element={<Role/>}/>
    </Routes>
  );
}
